











import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'AuthSwitcher'
})
export default class AuthSwitcher extends Vue {}
